interface Customer {
  address: string;
  display_name: string | null;
  last_visit_at: string;
}

interface Props { regulars: Customer[]; }

function timeAgo(iso: string) {
  const days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
  if (days <= 0) return 'today';
  if (days === 1) return '1 day ago';
  return `${days} days ago`;
}

export default function RegularsList({ regulars }: Props) {
  return (
    <div className="bg-white rounded-[10px] p-[18px]">
      <p className="font-heading text-[9px] text-body-grey mb-3.5">REGULARS</p>
      {regulars.length === 0 ? (
        <p className="font-grotesk text-[13px] text-body-grey">No regulars yet — keep stamping!</p>
      ) : (
        <ul className="flex flex-col gap-2.5">
          {regulars.map(c => (
            <li key={c.address} className="flex items-baseline justify-between gap-3">
              <span className="font-grotesk font-bold text-[15px] text-primary truncate">
                {c.display_name || 'Customer'}
              </span>
              <span className="font-grotesk font-medium text-[13px] text-[#a8a29e] flex-none">
                {timeAgo(c.last_visit_at)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
